import {useMemo} from "react";
import {useTranslation} from "react-i18next";
import * as yup from "yup";
import {yupResolver} from "@hookform/resolvers/yup";
import {useForm} from "react-hook-form";

export const useAddressForm = (data) => {
    const {t} = useTranslation();

    const defaultValues = useMemo(() => ({
        country: data?.country || "",
        addressLine1: data?.addressLine1 || "",
        addressLine2: data?.addressLine2 || "",
        city: data?.city || "",
        area: data?.area || "",
        code: data?.code || "",
    }), [data]);

    const schema = useMemo(() => yup.object().shape({
        country: yup.string().required(t("validation.required")),
        addressLine1: yup.string().required(t("validation.required")),
        addressLine2: yup.string(),
        city: yup.string().required(t("validation.required")),
        area: yup.string().required(t("validation.required")),
        code: yup.string().required(t("validation.required")),
    }), [t]);

    const {
        control,
        handleSubmit,
        formState: {errors, isValid, isDirty},
        watch,
        setValue,
    } = useForm({
        resolver: yupResolver(schema),
        defaultValues,
    });

    return {
        handleSubmit,
        control,
        errors,
        isValid,
        watch,
        setValue,
        isDirty,
    };
};
